import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { StatusFilter, TimeRangeFilter, BusinessServiceGroupFilter } from '../../filters';
import { BusinessServicesOverviewPanel } from '../../panels';

export const pageId = 'business-services-overview';

export default function BusinessServicesOverviewPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Business Services Overview`}>
                <FilterContainer>
                    <BusinessServiceGroupFilter />
                    <TimeRangeFilter required />
                    <StatusFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <BusinessServicesOverviewPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
